import type { IUseCase } from '@/shared/contracts/use-case.contract';

import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';

import { ENDPOINT, type Place } from '../../types/get-place';

type UseCaseInput = {
  lat: number;
  lon: number;
};

type UseCaseOutput = Place;

export class GetPlaceUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { lat, lon } = input;

    if (!lat || !lon) {
      throw new Error('Latitude and longitude are required');
    }

    const response = await this.client.sendRequest<UseCaseOutput, UseCaseInput>({
      method: HttpMethod.POST,
      endpoint: ENDPOINT,
      body: {
        lat,
        lon,
      },
    });

    return response;
  }
}
